import React, { useState, useEffect } from 'react';
import { 
  ClipboardDocumentListIcon,
  CloudArrowUpIcon,
  TrashIcon,
  ArrowDownTrayIcon,
  DocumentTextIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
  ArrowPathIcon
} from '@heroicons/react/24/outline';
import { toast } from 'react-toastify';
import api from '../../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import API_CONFIG from '../../config/api';
import { downloadAutenticato } from '../../utils/downloadFile';

const TabContratti = ({ 
  pratica, 
  ruoloUtente, 
  formatDate,
  onContrattiAggiornati 
}) => {
  const [contratti, setContratti] = useState([]);
  const [loadingContratti, setLoadingContratti] = useState(true);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadingContratto, setUploadingContratto] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({ current: 0, total: 0 });
  const [showModificaDatiModal, setShowModificaDatiModal] = useState(false);
  const [showAttivazioneModal, setShowAttivazioneModal] = useState(false);
  const [contrattoSelezionato, setContrattoSelezionato] = useState(null);
  const [datiContratto, setDatiContratto] = useState({
    vettura: '',
    durata_mesi: '',
    km_annui: '',
    canone_mensile: '',
    anticipo: '',
    commissione_agenzia: '',
    franchigia_kasko: '',
    franchigia_rca: '',
    franchigia_furto: '',
    colore_vettura: '',
    servizi_inclusi: [],
    optional_inclusi: [],
    settimane_consegna: '',
    note_contrattuali: ''
  });
  const [preventiviDisponibili, setPreventiviDisponibili] = useState([]);
  const [preventivoSelezionato, setPreventivoSelezionato] = useState(null);
  const [hasMultiplePreventiviApprovati, setHasMultiplePreventiviApprovati] = useState(false);
  const [noteVerifica, setNoteVerifica] = useState('');
  // Modifica admin del contratto da firmare (descrizione / sostituzione PDF)
  const [showModificaDaFirmare, setShowModificaDaFirmare] = useState(false);
  const [contrattoDaModificare, setContrattoDaModificare] = useState(null);
  const [modDescrizione, setModDescrizione] = useState('');
  const [modFile, setModFile] = useState(null);
  const [salvandoMod, setSalvandoMod] = useState(false);
  const [noteAttivazione, setNoteAttivazione] = useState('');
  const [analisiContratti, setAnalisiContratti] = useState(null);
  const [nuovoContratto, setNuovoContratto] = useState({
    tipo: 'contratto_da_firmare',
    descrizione: '',
    files: [],
    preventivo_id: null
  });
  const [dataPrevistConsegna, setDataPrevistConsegna] = useState('');

  useEffect(() => {
    if (pratica?.id) {
      fetchContratti();
    }
  }, [pratica?.id, ruoloUtente]);

  const fetchContratti = async () => {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}/api/pratica/${pratica.id}/contratti`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      if (response.data.success) {
        setContratti(response.data.contratti || []);
      }
    } catch (error) {
      console.error('Errore nel caricamento contratti:', error);
      toast.error('Errore nel caricamento dei contratti');
    } finally {
      setLoadingContratti(false);
    }
  };

  const fetchPreventiviDisponibili = async () => {
    try {
      // Usa l'API esistente per ottenere i preventivi della pratica
      const response = await api.get(
        `${API_CONFIG.BASE_URL}/api/pratica/${pratica.id}/preventivi`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      if (response.data.success) {
        // Filtra solo i preventivi approvati dal cliente
        const preventiviApprovati = (response.data.preventivi || []).filter(
          p => p.statoPreventivo === 'approvato_dal_cliente' || p.statoPreventivo === 'accettato'
        );
        
        // Trasforma i dati per il formato atteso con dettagli dall'offerta
        const preventiviFormatted = preventiviApprovati.map(preventivo => {
          // Parsing dei dati dell'offerta (che sono stringificati nel campo datiOfferta)
          let datiOfferta = {};
          try {
            datiOfferta = JSON.parse(preventivo.datiOfferta || '{}');
          } catch (e) {
            console.warn('Errore nel parsing datiOfferta per preventivo', preventivo.id);
            datiOfferta = {};
          }

          return {
            id: preventivo.id,
            vettura: `${preventivo.vettura?.brand || ''} ${preventivo.vettura?.modello || ''}`.trim(),
            canone: datiOfferta.canone || '0',
            durata: datiOfferta.durata || 'N/A',
            kmAnnui: datiOfferta.kmAnnui || 'N/A',
            anticipo: datiOfferta.anticipo || '0',
            tipoPreventivo: preventivo.tipoPreventivo,
            dataCreazione: preventivo.dataCreazione,
            immagine: preventivo.vettura?.immagine?.path_file || null,
            // Per ora tutti sono disponibili (implementeremo la logica dei contratti esistenti dopo)
            disponibilePerNuovoContratto: true
          };
        });

        setPreventiviDisponibili(preventiviFormatted);
        
        // Se è un contratto da firmare e c'è solo un preventivo disponibile, selezionalo automaticamente
        if (nuovoContratto.tipo === 'contratto_da_firmare' && preventiviFormatted.length === 1) {
          setPreventivoSelezionato(preventiviFormatted[0].id);
          setNuovoContratto(prev => ({ ...prev, preventivo_id: preventiviFormatted[0].id }));
        }
      }
    } catch (error) {
      console.error('Errore nel caricamento preventivi disponibili:', error);
      toast.error('Errore nel caricamento dei preventivi disponibili');
    }
  };

  const uploadContratto = async () => {
    if (!nuovoContratto.files.length) {
      toast.error('Seleziona almeno un file');
      return;
    }

    // Validazione: per i contratti da firmare è obbligatorio selezionare un preventivo
    if (nuovoContratto.tipo === 'contratto_da_firmare' && !nuovoContratto.preventivo_id) {
      toast.error('È obbligatorio selezionare un preventivo per i contratti da firmare');
      return;
    }

    try {
      setUploadingContratto(true);
      setUploadProgress({ current: 0, total: nuovoContratto.files.length });
      
      // Carica tutti i file uno per volta per mantenere la compatibilità con l'API esistente
      const uploadPromises = nuovoContratto.files.map(async (file, index) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('tipo', nuovoContratto.tipo);
        formData.append('descrizione', `${nuovoContratto.descrizione}${nuovoContratto.files.length > 1 ? ` (${index + 1}/${nuovoContratto.files.length})` : ''}`);
        
        // Aggiungi preventivo_id se selezionato
        if (nuovoContratto.preventivo_id) {
          formData.append('preventivo_id', nuovoContratto.preventivo_id);
        }

        const response = await api.post(
          `${API_CONFIG.BASE_URL}/api/pratica/${pratica.id}/contratti`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
        
        // Aggiorna il progresso
        setUploadProgress(prev => ({ ...prev, current: prev.current + 1 }));
        
        return response;
      });

      // Esegui tutti i caricamenti in parallelo
      const responses = await Promise.all(uploadPromises);
      
      // Verifica che tutti i caricamenti siano andati a buon fine
      const allSuccessful = responses.every(response => response.data.success);
      
      if (allSuccessful) {
        const fileCount = nuovoContratto.files.length;
        toast.success(`${fileCount} contratt${fileCount > 1 ? 'i caricati' : 'o caricato'} con successo`);
        setShowUploadModal(false);
        setNuovoContratto({ files: [], tipo: 'contratto_da_firmare', descrizione: '', preventivo_id: null });
        setPreventivoSelezionato(null);
        setUploadProgress({ current: 0, total: 0 });
        fetchContratti();
        if (onContrattiAggiornati) onContrattiAggiornati();
      } else {
        // Se alcuni caricamenti sono falliti, mostra un messaggio di errore parziale
        const failedCount = responses.filter(response => !response.data.success).length;
        const successCount = responses.length - failedCount;
        toast.warning(`${successCount} contratti caricati con successo, ${failedCount} falliti`);
        fetchContratti(); // Ricarica comunque per mostrare quelli caricati con successo
        if (onContrattiAggiornati) onContrattiAggiornati();
      }
    } catch (error) {
      console.error('Errore durante l\'upload:', error);
      const errorMessage = error.response?.data?.error || 'Errore durante il caricamento dei contratti';
      toast.error(errorMessage);
    } finally {
      setUploadingContratto(false);
      setUploadProgress({ current: 0, total: 0 });
    }
  };

  const eliminaContratto = async (contrattoId) => {
    if (!window.confirm('Sei sicuro di voler eliminare questo contratto?')) {
      return;
    }

    try {
      const response = await api.delete(`/pratica/${pratica.id}/contratti/${contrattoId}`);

      if (response.data.success) {
        toast.success('Contratto eliminato con successo');
        fetchContratti();
        if (onContrattiAggiornati) onContrattiAggiornati();
      }
    } catch (error) {
      console.error('Errore durante l\'eliminazione del contratto:', error);
      toast.error('Errore durante l\'eliminazione del contratto');
    }
  };

  const handleCaricaFirmato = async (contratto) => {
    // Validazione: verifica stato pratica
    if (pratica.statoPratica !== 'attesa_firma_contratto') {
      toast.error('Impossibile caricare contratto firmato: lo stato della pratica deve essere "Attesa Firma Contratto"');
      return;
    }

    // Validazione: verifica che esistano contratti da firmare
    const hasContrattiDaFirmare = contratti.some(c => c.tipo === 'contratto_da_firmare');
    if (!hasContrattiDaFirmare) {
      toast.error('Impossibile caricare contratto firmato: non sono presenti contratti da firmare');
      return;
    }

    // Validazione: verifica che il contratto sia di tipo 'contratto_da_firmare'
    if (contratto.tipo !== 'contratto_da_firmare') {
      toast.error('È possibile caricare un contratto firmato solo per i contratti da firmare');
      return;
    }

    // Validazione: verifica che il contratto abbia un preventivo associato
    if (!contratto.preventivo_id) {
      toast.error('Impossibile caricare contratto firmato: il contratto da firmare non ha un preventivo associato');
      return;
    }

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.pdf';
    input.multiple = true; // consenti il caricamento di più file firmati
    input.onchange = async (e) => {
      const files = Array.from(e.target.files || []);
      if (!files.length) return;
      try {
        let caricati = 0;
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const formData = new FormData();
          formData.append('file', file);
          formData.append('tipo', 'contratto_firmato');
          formData.append('preventivo_id', contratto.preventivo_id); // Associa al preventivo del contratto da firmare
          formData.append('descrizione', `Contratto firmato - ${contratto.nome_file}${files.length > 1 ? ` (${i + 1}/${files.length})` : ''}`);

          const response = await api.post(`/pratica/${pratica.id}/contratti`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          if (response.data.success) caricati++;
        }

        if (caricati > 0) {
          toast.success(caricati > 1
            ? `${caricati} contratti firmati caricati con successo`
            : 'Contratto firmato caricato con successo');
          fetchContratti();
          if (onContrattiAggiornati) onContrattiAggiornati();
        }
      } catch (error) {
        console.error('Errore durante il caricamento del contratto firmato:', error);
        const errorMessage = error.response?.data?.error || 'Errore durante il caricamento del contratto firmato';
        toast.error(errorMessage);
      }
    };
    input.click();
  };

  const modificaDatiContratto = async () => {
    if (!contrattoSelezionato) return;

    try {
      const response = await api.put(
        `/pratica/${pratica.id}/contratti/${contrattoSelezionato.id}/dati`,
        {
          datiContratto,
          noteVerifica
        }
      );

      if (response.data.success) {
        toast.success('Dati contratto aggiornati con successo');
        setShowModificaDatiModal(false);
        fetchContratti();
        if (onContrattiAggiornati) onContrattiAggiornati();
      }
    } catch (error) {
      console.error('Errore durante la modifica dati contratto:', error);
      const errorMessage = error.response?.data?.error || 'Errore durante la modifica dei dati del contratto';
      toast.error(errorMessage);
    }
  };

  const attivaContratto = async () => {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}/api/pratica/${pratica.id}/attiva-contratto`,
        { 
          note: noteAttivazione,
          dataPrevistConsegna: dataPrevistConsegna
        },
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      if (response.data.success) {
        toast.success('Contratto attivato con successo!');
        setShowAttivazioneModal(false);
        fetchContratti();
        if (onContrattiAggiornati) onContrattiAggiornati();
        // Aggiorna lo stato della pratica
        window.location.reload(); // Ricarica per aggiornare stato pratica
      }
    } catch (error) {
      console.error('Errore durante l\'attivazione contratto:', error);
      const errorMessage = error.response?.data?.error || 'Errore durante l\'attivazione del contratto';
      toast.error(errorMessage);
    }
  };

  const handleModificaDati = (contratto) => {
    setContrattoSelezionato(contratto);
    setShowModificaDatiModal(true);

    // Carica automaticamente i dati dal preventivo
    caricaDatiPreventivo();
  };

  // Apre il modale di modifica del contratto da firmare (admin)
  const handleModificaDaFirmare = (contratto) => {
    setContrattoDaModificare(contratto);
    setModDescrizione(contratto.descrizione || '');
    setModFile(null);
    setShowModificaDaFirmare(true);
  };

  // Salva la modifica: aggiorna descrizione e/o sostituisce il PDF
  const salvaModificaDaFirmare = async () => {
    if (!contrattoDaModificare) return;
    if (!modDescrizione.trim() && !modFile) {
      toast.error('Modifica la descrizione o seleziona un nuovo file');
      return;
    }
    setSalvandoMod(true);
    try {
      const fd = new FormData();
      if (modDescrizione.trim()) fd.append('descrizione', modDescrizione.trim());
      if (modFile) fd.append('file', modFile);
      const response = await api.put(`/pratica/${pratica.id}/contratti/${contrattoDaModificare.id}`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (response.data.success) {
        toast.success('Contratto da firmare aggiornato');
        setShowModificaDaFirmare(false);
        setContrattoDaModificare(null);
        setModFile(null);
        fetchContratti();
        if (onContrattiAggiornati) onContrattiAggiornati();
      }
    } catch (error) {
      console.error('Errore modifica contratto da firmare:', error);
      toast.error(error.response?.data?.error || 'Errore durante la modifica del contratto');
    } finally {
      setSalvandoMod(false);
    }
  };

  const canUploadContrattiDaFirmare = () => {
    return ruoloUtente === 'admin' && pratica.statoPratica === 'attesa_firma_contratto';
  };

  const canUploadContrattiFirmati = () => {
    // Deve essere agente/agenzia/subagente E stato attesa_firma_contratto
    if (!['agenzia', 'subagente', 'agente'].includes(ruoloUtente) || pratica.statoPratica !== 'attesa_firma_contratto') {
      return false;
    }
    
    // Verifica che esistano contratti da firmare
    const hasContrattiDaFirmare = contratti.some(c => c.tipo === 'contratto_da_firmare');
    return hasContrattiDaFirmare;
  };

  const canUploadContratti = () => {
    return canUploadContrattiDaFirmare() || canUploadContrattiFirmati();
  };

  const canDeleteContratti = () => {
    return ruoloUtente === 'admin';
  };

  const canDownloadContratti = () => {
    // Admin può sempre scaricare, altri solo in attesa firma contratto
    return ruoloUtente === 'admin' || pratica.statoPratica === 'attesa_firma_contratto';
  };

  const canModifyContractData = () => {
    return ruoloUtente === 'admin' && pratica.statoPratica === 'attesa_firma_contratto';
  };

  const canActivateContract = () => {
    // Verifica se l'admin può attivare il contratto basandosi sui contratti locali
    if (ruoloUtente !== 'admin' || pratica.statoPratica !== 'attesa_firma_contratto') {
      return false;
    }
    
    // Conta i contratti firmati e verificati
    const contrattiFirmati = contratti.filter(c => c.tipo === 'contratto_firmato');
    const contrattiVerificati = contratti.filter(c => c.stato_verifica === 'verificato');
    
    // Deve esserci almeno un contratto firmato e verificato
    return contrattiFirmati.length > 0 && contrattiVerificati.length > 0;
  };

  const getTipoContrattoLabel = (tipo) => {
    const tipi = {
      'contratto_da_firmare': 'Da Firmare',
      'contratto_firmato': 'Firmato',
      'contratto_attivo': 'Attivo'
    };
    return tipi[tipo] || tipo;
  };

  const getTipoContrattoColor = (tipo) => {
    const colori = {
      'contratto_da_firmare': 'bg-amber-100 text-amber-800 border-amber-200',
      'contratto_firmato': 'bg-emerald-100 text-emerald-800 border-emerald-200',
      'contratto_attivo': 'bg-blue-100 text-blue-800 border-blue-200'
    };
    return colori[tipo] || 'bg-gray-100 text-gray-800 border-gray-200';
  };

  const getTipoContrattoIcon = (tipo) => {
    // Rimuovo le icone per evitare problemi di wrapping
    return null;
  };

  const getStatoPraticaInfo = () => {
    const stati = {
      'attesa_firma_contratto': {
        colore: 'bg-amber-100 text-amber-800 border-amber-200',
        icona: <ExclamationTriangleIcon className="h-4 w-4" />,
        label: 'Attesa Firma Contratto'
      },
      'contratto_firmato': {
        colore: 'bg-emerald-100 text-emerald-800 border-emerald-200',
        icona: <CheckCircleIcon className="h-4 w-4" />,
        label: 'Contratto Firmato'
      }
    };
    return stati[pratica.statoPratica] || {
      colore: 'bg-gray-100 text-gray-800 border-gray-200',
      icona: <DocumentTextIcon className="h-4 w-4" />,
      label: pratica.statoPratica
    };
  };

  const getStatoVerificaInfo = (statoVerifica, tipoContratto) => {
    // Logica specifica per gli stati
    if (pratica.statoPratica === 'contratto_attivo' && tipoContratto === 'contratto_firmato') {
      return { label: 'Attivo', colore: 'bg-blue-100 text-blue-800' };
    }
    
    if (pratica.statoPratica === 'attesa_firma_contratto' && tipoContratto === 'contratto_da_firmare') {
      return { label: 'In Attesa', colore: 'bg-yellow-100 text-yellow-800' };
    }
    
    const stati = {
      'verificato': { label: 'Verificato', colore: 'bg-green-100 text-green-800' },
      'da_correggere': { label: 'Da Correggere', colore: 'bg-red-100 text-red-800' }
    };
    return stati[statoVerifica] || { label: 'Completato', colore: 'bg-gray-100 text-gray-800' };
  };

  // Carica dati preventivo per popolare contratto
  const caricaDatiPreventivo = async (preventivoId = null) => {
    try {
      setLoadingContratti(true);
      
      const url = preventivoId 
        ? `${API_CONFIG.BASE_URL}/api/pratica/${pratica.id}/contratti/dati-preventivo?preventivoId=${preventivoId}`
        : `${API_CONFIG.BASE_URL}/api/pratica/${pratica.id}/contratti/dati-preventivo`;
        
      const response = await api.get(url, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.data.success) {
        const { datiContratto, preventivoSelezionato, preventiviDisponibili, hasMultiplePreventiviApprovati } = response.data;
        
        setDatiContratto(datiContratto);
        setPreventivoSelezionato(preventivoSelezionato);
        setPreventiviDisponibili(preventiviDisponibili || []);
        setHasMultiplePreventiviApprovati(hasMultiplePreventiviApprovati || false);
        
        toast.success(`Dati caricati dal preventivo ${preventivoSelezionato.id}`);
      } else {
        toast.error(response.data.error || 'Errore nel caricamento dati preventivo');
      }
    } catch (error) {
      console.error('Errore caricamento dati preventivo:', error);
      toast.error('Errore nel caricamento dati preventivo');
    } finally {
      setLoadingContratti(false);
    }
  };

  // Gestisce la selezione di un preventivo diverso
  const handleSelezionaPreventivo = async (preventivoId) => {
    await caricaDatiPreventivo(preventivoId);
  };

  if (!pratica) {
    return (
      <div className="bg-white rounded-lg shadow-sm border p-6 text-center">
        <p className="text-gray-500">Nessuna pratica selezionata</p>
      </div>
    );
  }

  const statoPraticaInfo = getStatoPraticaInfo();

  return (
    <div className="bg-white rounded-lg shadow-sm border">
      <div className="px-6 py-4 border-b bg-gradient-to-r from-emerald-50 to-teal-50">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                Gestione Contratti
              </h3>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            {canActivateContract() && (
              <button
                onClick={() => setShowAttivazioneModal(true)}
                className="inline-flex items-center px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors shadow-sm"
              >
                <CheckCircleIcon className="h-4 w-4 mr-2" />
                Attiva Contratto
              </button>
            )}
            
            {canUploadContrattiDaFirmare() && (
              <button
                onClick={() => {
                  setNuovoContratto({ files: [], tipo: 'contratto_da_firmare', descrizione: '', preventivo_id: null });
                  setPreventivoSelezionato(null);
                  setShowUploadModal(true);
                  fetchPreventiviDisponibili();
                }}
                className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
              >
                <CloudArrowUpIcon className="h-4 w-4 mr-2" />
                Carica Contratti da Firmare
              </button>
            )}
            {canUploadContrattiFirmati() && (
              <button
                onClick={() => {
                  setNuovoContratto({ files: [], tipo: 'contratto_firmato', descrizione: '', preventivo_id: null });
                  setPreventivoSelezionato(null);
                  setShowUploadModal(true);
                  fetchPreventiviDisponibili();
                }}
                className="inline-flex items-center px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors"
              >
                <CheckCircleIcon className="h-4 w-4 mr-2" />
                Carica Contratti Firmati
              </button>
            )}
          </div>
        </div>
      </div>
      
      <div className="p-6">
        {loadingContratti ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
            <p className="mt-4 text-gray-500">Caricamento contratti...</p>
          </div>
        ) : contratti.length > 0 ? (
          <div className="space-y-4">
            {contratti.map((contratto) => {
              console.log(`🔍 Contratto ${contratto.id}: stato_verifica = "${contratto.stato_verifica}", tipo = "${contratto.tipo}"`);
              const statoVerifica = getStatoVerificaInfo(contratto.stato_verifica, contratto.tipo);
              
              return (
                <div key={contratto.id} className="border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
                  {/* Header contratto */}
                  <div className="px-6 py-4 border-b border-gray-100 bg-gray-50 rounded-t-lg">
                    <div className="flex justify-between items-center">
                      <div>
                        <div className="flex items-center gap-2 mb-1 flex-wrap">
                          <h4 className="text-lg font-semibold text-gray-900 truncate">
                            {contratto.descrizione || contratto.nome_file}
                          </h4>
                          <span className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getTipoContrattoColor(contratto.tipo)}`}>
                            {getTipoContrattoLabel(contratto.tipo)}
                          </span>
                        </div>
                        <p className="text-sm text-gray-600">
                          Caricato il {formatDate(contratto.data_caricamento)}
                          {contratto.preventivo_id && ` • Preventivo #${contratto.preventivo_id}`}
                        </p>
                      </div>
                      
                      <div className="flex items-center space-x-2">
                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${statoVerifica.colore}`}>
                          {statoVerifica.label}
                        </span>
                        
                        {canDownloadContratti() && (
                          <button
                            onClick={() => downloadAutenticato(`/api/pratica/${pratica.id}/contratti/${contratto.id}/download`, contratto.nome_file || `contratto_${contratto.id}.pdf`).catch((e) => toast.error(e.message || 'Errore nel download del contratto'))}
                            className="inline-flex items-center px-3 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
                            title="Scarica contratto"
                          >
                            <ArrowDownTrayIcon className="h-4 w-4 mr-1" />
                            Scarica
                          </button>
                        )}
                        
                        {canModifyContractData() && contratto.tipo === 'contratto_firmato' && (
                          <button
                            onClick={() => handleModificaDati(contratto)}
                            className="inline-flex items-center px-3 py-2 bg-amber-600 text-white text-sm font-medium rounded-lg hover:bg-amber-700 transition-colors shadow-sm"
                            title="Modifica dati contratto"
                          >
                            <DocumentTextIcon className="h-4 w-4 mr-1" />
                            Modifica
                          </button>
                        )}

                        {canModifyContractData() && contratto.tipo === 'contratto_da_firmare' && (
                          <button
                            onClick={() => handleModificaDaFirmare(contratto)}
                            className="inline-flex items-center px-3 py-2 bg-amber-600 text-white text-sm font-medium rounded-lg hover:bg-amber-700 transition-colors shadow-sm"
                            title="Modifica contratto da firmare (descrizione / sostituisci PDF)"
                          >
                            <DocumentTextIcon className="h-4 w-4 mr-1" />
                            Modifica
                          </button>
                        )}
                        
                        {canUploadContrattiFirmati() && contratto.tipo === 'contratto_da_firmare' && (
                          <button
                            onClick={() => handleCaricaFirmato(contratto)}
                            className="inline-flex items-center px-3 py-2 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition-colors shadow-sm"
                            title="Carica versione firmata"
                          >
                            <CheckCircleIcon className="h-4 w-4 mr-1" />
                            Carica Firmato
                          </button>
                        )}
                        
                        {canDeleteContratti() && (
                          <button
                            onClick={() => eliminaContratto(contratto.id)}
                            className="inline-flex items-center px-3 py-2 bg-red-600 text-white text-sm font-medium rounded-lg hover:bg-red-700 transition-colors shadow-sm"
                            title="Elimina contratto"
                          >
                            <TrashIcon className="h-4 w-4 mr-1" />
                            Elimina
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  
                  {/* Note verifica se presenti */}
                  {contratto.note_verifica && (
                    <div className="px-6 pb-4">
                      <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                        <p className="text-sm text-yellow-800">
                          <span className="font-medium">Note di verifica:</span> {contratto.note_verifica}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="mx-auto w-24 h-24 bg-gradient-to-br from-emerald-100 to-teal-100 rounded-full flex items-center justify-center mb-6">
              <ClipboardDocumentListIcon className="h-12 w-12 text-emerald-500" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Nessun contratto presente</h3>
            <p className="text-gray-600 mb-8 max-w-md mx-auto leading-relaxed">
              {canUploadContratti()
                ? 'Carica il contratto da far firmare al cliente per procedere con la pratica.'
                : 'I contratti verranno visualizzati qui una volta caricati dall\'amministratore.'}
            </p>
            {canUploadContratti() && (
              <button
                onClick={() => {
                  setNuovoContratto({ files: [], tipo: 'contratto_da_firmare', descrizione: '', preventivo_id: null });
                  setPreventivoSelezionato(null);
                  setShowUploadModal(true);
                  fetchPreventiviDisponibili();
                }}
                className="inline-flex items-center px-6 py-3 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition-colors shadow-sm"
              >
                <CloudArrowUpIcon className="h-5 w-5 mr-2" />
                Carica Primo Contratto
              </button>
            )}
          </div>
        )}
      </div>

      {showUploadModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg max-h-[90vh] overflow-y-auto shadow-xl">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-lg font-semibold text-gray-900">
                📤 Carica Contratto{nuovoContratto.files.length > 1 ? 'i' : ''}
              </h3>
              <button
                onClick={() => {
                  setShowUploadModal(false);
                  setUploadProgress({ current: 0, total: 0 });
                }}
                className="text-gray-400 hover:text-gray-500 transition-colors"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
            
            <div className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  File Contratto{nuovoContratto.files.length > 1 ? 'i' : ''} (PDF) *
                </label>
                <div className="relative">
                  <input
                    type="file"
                    accept=".pdf"
                    onChange={(e) => {
                      const nuovi = Array.from(e.target.files || []);
                      setNuovoContratto(prev => {
                        const esistenti = prev.files || [];
                        const chiavi = new Set(esistenti.map(f => `${f.name}_${f.size}`));
                        const daAggiungere = nuovi.filter(f => !chiavi.has(`${f.name}_${f.size}`));
                        return { ...prev, files: [...esistenti, ...daAggiungere] };
                      });
                      e.target.value = ''; // reset per poter riselezionare/aggiungere altri file
                    }}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    multiple
                  />
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <DocumentTextIcon className="h-5 w-5 text-gray-400" />
                  </div>
                </div>
                {nuovoContratto.files.length > 0 && (
                  <div className="mt-3">
                    <p className="text-sm text-green-600 mb-2">
                      ✓ {nuovoContratto.files.length} file selezionati:
                    </p>
                    <div className="space-y-2 max-h-32 overflow-y-auto">
                      {nuovoContratto.files.map((file, index) => (
                        <div key={index} className="flex items-center justify-between bg-gray-50 p-2 rounded-lg">
                          <div className="flex items-center space-x-2 flex-1 min-w-0">
                            <DocumentTextIcon className="h-4 w-4 text-gray-500 flex-shrink-0" />
                            <span className="text-sm text-gray-700 truncate" title={file.name}>
                              {file.name}
                            </span>
                            <span className="text-xs text-gray-500 flex-shrink-0">
                              ({(file.size / 1024 / 1024).toFixed(1)} MB)
                            </span>
                          </div>
                          <button
                            onClick={() => {
                              const newFiles = nuovoContratto.files.filter((_, i) => i !== index);
                              setNuovoContratto(prev => ({ ...prev, files: newFiles }));
                            }}
                            className="text-red-500 hover:text-red-700 p-1 flex-shrink-0"
                            title="Rimuovi file"
                          >
                            <XMarkIcon className="h-4 w-4" />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Descrizione *
                </label>
                <input
                  type="text"
                  value={nuovoContratto.descrizione}
                  onChange={(e) => setNuovoContratto(prev => ({ ...prev, descrizione: e.target.value }))}
                  placeholder="es. Contratto di noleggio lungo termine"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tipo Contratto{nuovoContratto.files.length > 1 ? 'i' : ''} *
                </label>
                <select
                  value={nuovoContratto.tipo}
                  onChange={(e) => setNuovoContratto(prev => ({ ...prev, tipo: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                >
                  {canUploadContrattiDaFirmare() && (
                    <option value="contratto_da_firmare">📝 Da Firmare (Solo Admin)</option>
                  )}
                  {canUploadContrattiFirmati() && (
                    <option value="contratto_firmato">✅ Firmati (Agenzia)</option>
                  )}
                  {ruoloUtente === 'admin' && (
                    <option value="contratto_firmato">✅ Firmati</option>
                  )}
                </select>
              </div>

              {/* Selezione Preventivo */}
              {(nuovoContratto.tipo === 'contratto_da_firmare' || preventiviDisponibili.length > 0) && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {nuovoContratto.tipo === 'contratto_da_firmare' ? 'Preventivo di Riferimento *' : 'Preventivo Associato (Opzionale)'}
                  </label>
                  
                  {preventiviDisponibili.length === 0 ? (
                    <div className="text-amber-700 bg-amber-50 p-3 rounded-lg border border-amber-200 text-sm">
                      <div className="flex items-center">
                        <ExclamationTriangleIcon className="h-4 w-4 mr-2" />
                        <span>Nessun preventivo approvato disponibile</span>
                      </div>
                    </div>
                  ) : (
                    <div className="border border-gray-300 rounded-lg max-h-64 overflow-y-auto">
                      {preventiviDisponibili.map((preventivo) => {
                        const isDisponibile = preventivo.disponibilePerNuovoContratto;
                        const isSelected = preventivoSelezionato === preventivo.id;
                        const isDisabled = !isDisponibile && nuovoContratto.tipo === 'contratto_da_firmare';
                        
                        return (
                          <div 
                            key={preventivo.id}
                            className={`p-4 border-b border-gray-100 last:border-b-0 cursor-pointer transition-colors ${
                              isDisabled
                                ? 'bg-gray-50 cursor-not-allowed opacity-60'
                                : isSelected 
                                  ? 'bg-blue-50 border-blue-200' 
                                  : 'hover:bg-gray-50'
                            }`}
                            onClick={() => {
                              if (!isDisabled) {
                                const newId = isSelected ? null : preventivo.id;
                                setPreventivoSelezionato(newId);
                                setNuovoContratto(prev => ({ ...prev, preventivo_id: newId }));
                              }
                            }}
                          >
                            <div className="flex items-start space-x-4">
                              <input
                                type="radio"
                                checked={isSelected}
                                readOnly
                                className="mt-2 flex-shrink-0"
                                disabled={isDisabled}
                              />
                              
                              {/* Immagine vettura */}
                              {preventivo.immagine && (
                                <div className="flex-shrink-0">
                                  <img 
                                    src={`${API_CONFIG.BASE_URL}${preventivo.immagine}`}
                                    alt={preventivo.vettura}
                                    className="w-16 h-12 object-cover rounded-lg border border-gray-200"
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                    }}
                                  />
                                </div>
                              )}
                              
                              <div className="flex-1 min-w-0">
                                <div className="flex items-center justify-between mb-2">
                                  <div className="flex items-center space-x-2">
                                    <span className="font-medium text-gray-900 text-sm">
                                      Preventivo #{preventivo.id}
                                    </span>
                                    {!isDisponibile && nuovoContratto.tipo === 'contratto_da_firmare' && (
                                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600">
                                        Già utilizzato
                                      </span>
                                    )}
                                  </div>
                                  {isSelected && (
                                    <CheckCircleIcon className="h-5 w-5 text-blue-600 flex-shrink-0" />
                                  )}
                                </div>
                                
                                {/* Dettagli vettura */}
                                <div className="mb-2">
                                  <h4 className="font-medium text-gray-800 text-sm">{preventivo.vettura}</h4>
                                  <p className="text-xs text-gray-500">{preventivo.tipoPreventivo}</p>
                                </div>
                                
                                {/* Dettagli economici */}
                                <div className="grid grid-cols-2 gap-3 text-xs">
                                  <div className="space-y-1">
                                    <div className="flex justify-between">
                                      <span className="text-gray-600">Canone:</span>
                                      <span className="font-medium text-green-700">€{preventivo.canone}/mese</span>
                                    </div>
                                    <div className="flex justify-between">
                                      <span className="text-gray-600">Durata:</span>
                                      <span className="font-medium">{preventivo.durata} mesi</span>
                                    </div>
                                  </div>
                                  <div className="space-y-1">
                                    <div className="flex justify-between">
                                      <span className="text-gray-600">KM Annui:</span>
                                      <span className="font-medium">{preventivo.kmAnnui || 'N/A'}</span>
                                    </div>
                                    <div className="flex justify-between">
                                      <span className="text-gray-600">Anticipo:</span>
                                      <span className="font-medium">€{preventivo.anticipo || '0'}</span>
                                    </div>
                                  </div>
                                </div>
                                
                                {/* Data creazione */}
                                <div className="mt-2 pt-2 border-t border-gray-100">
                                  <span className="text-xs text-gray-500">
                                    Creato: {formatDate(preventivo.dataCreazione)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}

              {nuovoContratto.tipo === 'contratto_da_firmare' && (
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                  <div className="flex items-start">
                    <ExclamationTriangleIcon className="h-5 w-5 text-amber-600 mt-0.5 mr-2" />
                    <div>
                      <h4 className="text-sm font-medium text-amber-800">Contratti da firmare</h4>
                      <p className="text-sm text-amber-700 mt-1">
                        Questi contratti saranno visibili all'agenzia per il download e la firma.
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {nuovoContratto.tipo === 'contratto_firmato' && (
                <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4">
                  <div className="flex items-start">
                    <CheckCircleIcon className="h-5 w-5 text-emerald-600 mt-0.5 mr-2" />
                    <div>
                      <h4 className="text-sm font-medium text-emerald-800">Contratti firmati</h4>
                      <p className="text-sm text-emerald-700 mt-1">
                        Questi contratti sono già stati firmati dal cliente.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            
            <div className="flex justify-end space-x-3 pt-6 border-t border-gray-200 mt-6">
              <button
                onClick={() => {
                  setShowUploadModal(false);
                  setUploadProgress({ current: 0, total: 0 });
                }}
                className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                disabled={uploadingContratto}
              >
                Annulla
              </button>
              <button
                onClick={uploadContratto}
                disabled={uploadingContratto || !nuovoContratto.files.length || !nuovoContratto.descrizione}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center"
              >
                {uploadingContratto ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    {uploadProgress.total > 1 ? (
                      `Caricamento... (${uploadProgress.current}/${uploadProgress.total})`
                    ) : (
                      'Caricamento...'
                    )}
                  </>
                ) : (
                  <>
                    <CloudArrowUpIcon className="h-4 w-4 mr-2" />
                    Carica Contratto{nuovoContratto.files.length > 1 ? 'i' : ''}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Modifica Dati Contratti */}
      {showModificaDatiModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-gradient-to-r from-indigo-600 to-blue-600 text-white p-6 rounded-t-2xl">
              <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold flex items-center">
                  <DocumentTextIcon className="h-7 w-7 mr-3" />
                  Modifica Dati Contratti
                </h2>
                <button
                  onClick={() => setShowModificaDatiModal(false)}
                  className="text-white hover:text-gray-200 transition-colors"
                >
                  <XMarkIcon className="h-6 w-6" />
                </button>
              </div>
              <p className="text-indigo-100 mt-2">
                Verifica e modifica i dati dei contratti prima dell'attivazione
              </p>
            </div>

            <div className="p-6 space-y-8">
              {/* Sezione Vettura */}
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                  <div className="h-2 w-2 bg-blue-500 rounded-full mr-3"></div>
                  Informazioni Vettura
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Vettura
                    </label>
                    <input
                      type="text"
                      value={datiContratto.vettura}
                      onChange={(e) => setDatiContratto({...datiContratto, vettura: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Marca e modello"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Colore Vettura
                    </label>
                    <input
                      type="text"
                      value={datiContratto.colore_vettura}
                      onChange={(e) => setDatiContratto({...datiContratto, colore_vettura: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Colore della vettura"
                    />
                  </div>
                </div>
              </div>

              {/* Sezione Condizioni Contrattuali */}
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                  <div className="h-2 w-2 bg-green-500 rounded-full mr-3"></div>
                  Condizioni Contrattuali
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Durata (mesi)
                    </label>
                    <input
                      type="number"
                      value={datiContratto.durata_mesi || ''}
                      onChange={(e) => setDatiContratto(prev => ({
                        ...prev,
                        durata_mesi: e.target.value
                      }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="36"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      KM Annui
                    </label>
                    <input
                      type="number"
                      value={datiContratto.km_annui || ''}
                      onChange={(e) => setDatiContratto(prev => ({
                        ...prev,
                        km_annui: e.target.value
                      }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="15000"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Settimane Consegna
                    </label>
                    <input
                      type="number"
                      value={datiContratto.settimane_consegna || ''}
                      onChange={(e) => setDatiContratto(prev => ({
                        ...prev,
                        settimane_consegna: e.target.value
                      }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="4"
                    />
                  </div>
                </div>
              </div>

              {/* Sezione Economica */}
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                  <div className="h-2 w-2 bg-yellow-500 rounded-full mr-3"></div>
                  Condizioni Economiche
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Canone Mensile (€)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      value={datiContratto.canone_mensile || ''}
                      onChange={(e) => setDatiContratto(prev => ({
                        ...prev,
                        canone_mensile: e.target.value
                      }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="299.00"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Anticipo (€)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      value={datiContratto.anticipo || ''}
                      onChange={(e) => setDatiContratto(prev => ({
                        ...prev,
                        anticipo: e.target.value
                      }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="0.00"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Commissione Agenzia (€)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      value={datiContratto.commissione_agenzia || ''}
                      onChange={(e) => setDatiContratto(prev => ({
                        ...prev,
                        commissione_agenzia: e.target.value
                      }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="0.00"
                    />
                  </div>
                </div>
              </div>

              {/* Sezione Franchigie */}
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                  <div className="h-2 w-2 bg-red-500 rounded-full mr-3"></div>
                  Franchigie Assicurative
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Franchigia Kasko (€)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      value={datiContratto.franchigia_kasko}
                      onChange={(e) => setDatiContratto({...datiContratto, franchigia_kasko: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="0.00"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Franchigia RCA (€)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      value={datiContratto.franchigia_rca}
                      onChange={(e) => setDatiContratto({...datiContratto, franchigia_rca: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="0.00"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Franchigia Furto (€)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      value={datiContratto.franchigia_furto}
                      onChange={(e) => setDatiContratto({...datiContratto, franchigia_furto: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="0.00"
                    />
                  </div>
                </div>
              </div>

              {/* Sezione Note */}
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                  <div className="h-2 w-2 bg-purple-500 rounded-full mr-3"></div>
                  Note e Verifiche
                </h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Note Contrattuali
                    </label>
                    <textarea
                      value={datiContratto.note_contrattuali}
                      onChange={(e) => setDatiContratto({...datiContratto, note_contrattuali: e.target.value})}
                      rows={3}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Note aggiuntive sui contratti..."
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Note di Verifica Admin
                    </label>
                    <textarea
                      value={noteVerifica}
                      onChange={(e) => setNoteVerifica(e.target.value)}
                      rows={3}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Note di verifica dell'amministratore..."
                    />
                  </div>
                </div>
              </div>

              {/* Selezione Preventivo (se multiple preventivi approvati) */}
              {hasMultiplePreventiviApprovati && (
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                  <h3 className="text-lg font-semibold text-blue-800 mb-3 flex items-center">
                    <DocumentTextIcon className="h-5 w-5 mr-2" />
                    Seleziona Preventivo di Riferimento
                  </h3>
                  <div className="grid grid-cols-1 gap-3">
                    {preventiviDisponibili.map((prev) => (
                      <div 
                        key={prev.id}
                        className={`p-3 rounded border-2 cursor-pointer transition-all ${
                          prev.isSelected 
                            ? 'border-blue-500 bg-blue-100' 
                            : 'border-gray-200 bg-white hover:border-blue-300'
                        }`}
                        onClick={() => handleSelezionaPreventivo(prev.id)}
                      >
                        <div className="flex justify-between items-center">
                          <div>
                            <div className="font-medium text-gray-900">
                              Preventivo #{prev.id} - {prev.vettura}
                            </div>
                            <div className="text-sm text-gray-600">
                              {prev.tipoPreventivo} • €{prev.canone}/mese • {prev.durata} mesi
                            </div>
                            <div className="text-xs text-gray-500">
                              Creato: {formatDate(prev.dataCreazione)}
                            </div>
                          </div>
                          {prev.isSelected && (
                            <CheckCircleIcon className="h-6 w-6 text-blue-600" />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Informazioni Preventivo Selezionato */}
              {preventivoSelezionato && (
                <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                  <h4 className="font-medium text-green-800 mb-2">
                    📄 Preventivo di Riferimento: #{preventivoSelezionato.id}
                  </h4>
                  <p className="text-sm text-green-700">
                    Tipo: {preventivoSelezionato.tipoPreventivo} • 
                    Creato: {formatDate ? formatDate(preventivoSelezionato.dataCreazione) : preventivoSelezionato.dataCreazione}
                  </p>
                </div>
              )}

              {/* Dati Vettura */}
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                  🚗 Dati Vettura
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Vettura
                    </label>
                    <input
                      type="text"
                      value={datiContratto.vettura?.descrizione_completa || datiContratto.vettura || ''}
                      onChange={(e) => setDatiContratto(prev => ({
                        ...prev,
                        vettura: e.target.value
                      }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Marca e modello vettura"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Colore Vettura
                    </label>
                    <input
                      type="text"
                      value={datiContratto.colore_vettura || ''}
                      onChange={(e) => setDatiContratto(prev => ({
                        ...prev,
                        colore_vettura: e.target.value
                      }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Colore della vettura"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Modal */}
            <div className="bg-gray-50 px-6 py-4 rounded-b-2xl flex justify-between items-center">
              <button
                onClick={() => caricaDatiPreventivo()}
                className="px-4 py-2 text-blue-600 hover:text-blue-800 font-medium transition-colors flex items-center"
              >
                <ArrowPathIcon className="h-4 w-4 mr-2" />
                Ricarica da Preventivo
              </button>
              
              <div className="flex space-x-3">
                <button
                  onClick={() => setShowModificaDatiModal(false)}
                  className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors"
                >
                  Annulla
                </button>
                <button
                  onClick={modificaDatiContratto}
                  disabled={uploadingContratto}
                  className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors disabled:opacity-50 flex items-center"
                >
                  {uploadingContratto ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      Salvando...
                    </>
                  ) : (
                    <>
                      <CheckCircleIcon className="h-4 w-4 mr-2" />
                      Salva Modifiche
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAttivazioneModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg shadow-xl">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-lg font-semibold text-gray-900">
                🎯 Attivazione Contratti
              </h3>
              <button
                onClick={() => setShowAttivazioneModal(false)}
                className="text-gray-400 hover:text-gray-500 transition-colors"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
            
            {/* Riepilogo situazione basato sui dati locali */}
            <div className="mb-6 p-4 bg-blue-50 rounded-lg">
              <h4 className="font-medium text-blue-900 mb-2">Riepilogo Situazione</h4>
              <div className="text-sm text-blue-800 space-y-1">
                <p>• Contratti caricati: <span className="font-medium">{contratti.length}</span></p>
                <p>• Contratti firmati: <span className="font-medium">{contratti.filter(c => c.tipo === 'contratto_firmato').length}</span></p>
                <p>• Contratti verificati: <span className="font-medium">{contratti.filter(c => c.stato_verifica === 'verificato').length}</span></p>
                {contratti.filter(c => c.tipo === 'contratto_firmato').length === 0 && (
                  <p className="text-amber-700 font-medium">⚠️ Nessun contratto firmato presente</p>
                )}
                {contratti.filter(c => c.stato_verifica === 'verificato').length === 0 && (
                  <p className="text-amber-700 font-medium">⚠️ Nessun contratto verificato presente</p>
                )}
              </div>
            </div>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Data Prevista Consegna (opzionale)
                </label>
                <input
                  type="date"
                  value={dataPrevistConsegna}
                  onChange={(e) => setDataPrevistConsegna(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Note di Attivazione (opzionale)
                </label>
                <textarea
                  value={noteAttivazione}
                  onChange={(e) => setNoteAttivazione(e.target.value)}
                  placeholder="Note sull'attivazione dei contratti..."
                  rows={3}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors"
                />
              </div>
              
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <div className="flex items-start">
                  <CheckCircleIcon className="h-5 w-5 text-green-600 mt-0.5 mr-2" />
                  <div>
                    <h4 className="text-sm font-medium text-green-800">Pronto per l'attivazione</h4>
                    <p className="text-sm text-green-700 mt-1">
                      I contratti verranno attivati e la pratica passerà allo stato "Contratti Attivi".
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="flex justify-end space-x-3 pt-6 border-t border-gray-200 mt-6">
              <button
                onClick={() => setShowAttivazioneModal(false)}
                className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Annulla
              </button>
              <button
                onClick={attivaContratto}
                className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center"
              >
                <CheckCircleIcon className="h-4 w-4 mr-2" />
                Attiva Contratti
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modale modifica contratto da firmare (admin) */}
      {showModificaDaFirmare && contrattoDaModificare && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
            <div className="flex items-center justify-between px-5 py-4 border-b">
              <h3 className="text-lg font-semibold text-gray-900">Modifica contratto da firmare</h3>
              <button onClick={() => { setShowModificaDaFirmare(false); setContrattoDaModificare(null); setModFile(null); }}
                className="text-gray-400 hover:text-gray-600">
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
            <div className="p-5 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Descrizione</label>
                <input type="text" value={modDescrizione} onChange={(e) => setModDescrizione(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                  placeholder="Descrizione del contratto" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Sostituisci PDF <span className="text-gray-400 font-normal">(opzionale)</span></label>
                <input type="file" accept=".pdf"
                  onChange={(e) => setModFile(e.target.files && e.target.files[0])}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                {modFile
                  ? <p className="text-xs text-emerald-600 mt-1">✓ Nuovo file: {modFile.name}</p>
                  : <p className="text-xs text-gray-500 mt-1">File attuale: {contrattoDaModificare.nome_file}</p>}
                <p className="text-[11px] text-gray-400 mt-1">Se carichi un nuovo PDF, sostituirà quello attuale.</p>
              </div>
            </div>
            <div className="flex justify-end gap-2 px-5 py-4 border-t">
              <button onClick={() => { setShowModificaDaFirmare(false); setContrattoDaModificare(null); setModFile(null); }}
                className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50">Annulla</button>
              <button onClick={salvaModificaDaFirmare} disabled={salvandoMod}
                className="px-4 py-2 text-sm bg-amber-600 text-white rounded-lg hover:bg-amber-700 disabled:opacity-50">
                {salvandoMod ? 'Salvataggio…' : 'Salva modifiche'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TabContratti; 